import {ValueObject} from '@s-ui/domain'

export class UploadBuyerIdRequestTransactionsValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.documentBack
   * @param {String} data.documentFront
   */
  constructor({documentBack, documentFront, tradeId}) {
    super()

    this._documentBack = documentBack
    this._documentFront = documentFront
    this._tradeId = tradeId
  }

  static create = ({documentBack, documentFront, tradeId}) => {
    return new UploadBuyerIdRequestTransactionsValueObject({
      documentBack,
      documentFront,
      tradeId
    })
  }

  toJSON() {
    return {
      documentBack: this._documentBack,
      documentFront: this._documentFront,
      tradeId: this._tradeId
    }
  }
}
